/** Split "Monday: Closed" into label + boldable value for card hours. */
export function splitHoursMetadataLine(line: string): {
  label: string | null;
  value: string;
} {
  const colonIndex = line.indexOf(":");
  if (colonIndex === -1) {
    return { label: null, value: line };
  }

  return {
    label: line.slice(0, colonIndex + 1),
    value: line.slice(colonIndex + 1).trimStart(),
  };
}
